/** Maintenance dates in the admin form are Moscow wall-clock values, never browser-local dates. */
export interface MaintenanceSettings {
  enabled: boolean;
  startAt: string;
  endAt: string;
  notifyDaysBefore: number;
  subject: string;
  bodyHtml: string;
}

export interface MaintenanceWindow extends MaintenanceSettings {
  id: number;
  notifyClaimedAt: string | null;
  notifyFinishedAt: string | null;
  notifySent: number;
  notifyFailed: number;
  notifySkipped: number;
  notifyError: string | null;
}

export interface MaintenanceStatus {
  id: number | null;
  phase: 'NORMAL' | 'WARNING' | 'BLOCK' | 'FINISHED';
  startAt: string | null;
  endAt: string | null;
  notifyFrom: string | null;
  moscowDate: string;
  serverNow: string;
  portalUrl: string;
  contactPhone: string;
  contactEmail: string;
  messageHtml: string;
}

export const MAINTENANCE_DEFAULT_SUBJECT = 'Проведение технических работ';
export const MAINTENANCE_DEFAULT_HTML = `<p>Добрый день.</p>
<p>С {start} по {end} на портале {portalUrl} будут проводиться технические работы и портал будет недоступен.</p>
<p>С уважением,<br/>Команда Камоцци</p>`;
